// src/pages/termsAndCondition/TermsAndConditions.js
import React, { useEffect, useMemo, useState } from "react";
import { Box, Container, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import DraftRiskTermsDocument from "../../components/terms/DraftRiskTermsDocument";
import projectsData from "../../data/projects.json";
import comingProjectsData from "../../data/comingProjects.json";

const allProjectsData = [...projectsData, ...comingProjectsData];

function pickProjectTaxId(project) {
  return (
    project?.series?.[0]?.tokenContent?.Issuer_CNPJ ||
    project?.series?.[0]?.buyInstructions?.parameters?.Issuer_CNPJ ||
    project?.tokenContent?.Issuer_CNPJ ||
    project?.series?.[0]?.tokenContent?.Coffee_ProducerId ||
    project?.tokenContent?.Coffee_ProducerId ||
    project?.series?.[0]?.buyInstructions?.parameters?.Coffee_ProducerId ||
    ""
  );
}

const TermsAndConditions = () => {
  const { t, i18n } = useTranslation('common');
  const location = useLocation();

  const ptLang = 'pt-BR';
  const enLang = 'en-US';

  const { buyerName, clientName, projectTitle, projectId, taxId } = useMemo(() => {
    const sp = new URLSearchParams(location.search || '');
    return {
      buyerName: sp.get('buyer') || '',
      clientName: sp.get('client') || '',
      projectTitle: sp.get('project') || '',
      projectId: sp.get('projectId') || '',
      taxId: sp.get('taxId') || '',
    };
  }, [location.search]);

  const project = useMemo(() => {
    if (projectId) {
      return allProjectsData.find((p) => String(p?.id) === String(projectId)) || null;
    }
    if (projectTitle) {
      return allProjectsData.find((p) => String(p?.projectTitle) === String(projectTitle)) || null;
    }
    return null;
  }, [projectId, projectTitle]);

  const resolvedClient = clientName || project?.organizationName || t('termsPage.defaultClientName', 'Innova');
  const resolvedTaxId = taxId || pickProjectTaxId(project);
  const defaultLang = (String(i18n?.resolvedLanguage || i18n?.language || '')).toLowerCase().startsWith('pt') ? ptLang : enLang;
  const [activeLang, setActiveLang] = useState(defaultLang);

  useEffect(() => {
    setActiveLang(defaultLang);
  }, [defaultLang]);

  return (
    <Container>
      <Box sx={{ mb: 2 }}>
        <Tabs
          value={activeLang}
          onChange={(_, v) => setActiveLang(v)}
          variant="standard"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab value={ptLang} label="Português (PT-BR)" />
          <Tab value={enLang} label="English (EN-US)" />
        </Tabs>
      </Box>
      <DraftRiskTermsDocument
        language={activeLang}
        buyerName={buyerName}
        clientName={resolvedClient}
        projectTitle={projectTitle}
        taxId={resolvedTaxId}
      />
    </Container>
  );
};

export default TermsAndConditions;
